import { default as axios } from "./config";

export const fetchUsersInfoApi = () =>
  axios({
    method: "GET",
    url: `/api/v1/users/info.json`,
  });

export const signOutApi = () =>
  axios({
    method: "DELETE",
    url: `/users/sign_out`,
    data: {
      [(document.querySelector(`meta[name="csrf-param"]`) as any).content]: (
        document.querySelector(`meta[name="csrf-token"]`) as any
      ).content,
    },
  });

export const fetchArticlesApi = (params: any) =>
  axios({
    method: "GET",
    url: `/api/v1/articles.json`,
    params,
  });

export const addArticlesApi = (data: any) =>
  axios({
    method: "POST",
    url: `/api/v1/articles.json`,
    data,
  });

export const changeHaokanApi = (id: any) =>
  axios({
    method: "POST",
    url: `/api/v1/articles/${id}/haokan`,
  });

export const changeGuanwangApi = (id: any) =>
  axios({
    method: "POST",
    url: `/api/v1/articles/${id}/guanwang`,
  });

export const hiddenArticlesApi = (id: any) =>
  axios({
    method: "POST",
    url: `/api/v1/articles/${id}/hidden`,
  });

export const editArticlesApi = (id: any, data: any) => {
  return axios({
    method: "PATCH",
    url: `/api/v1/articles/${id}`,
    data,
  });
};

export const deleteArticlesApi = (id: any) =>
  axios({
    method: "DELETE",
    url: `/api/v1/articles/${id}`,
  });

export const userViewsApi = (id: any) =>
  axios({
    method: "POST",
    url: `/api/v1/articles/${id}/user_views`,
  });

export const fetchEvaluatesApi = (data: any) =>
  axios({
    method: "POST",
    url: `/api/v1/articles/evaluates`,
    data,
  });

export const updateUserInfoApi = (data: any) =>
  axios({
    method: "POST",
    url: `/api/v1/users/update_info`,
    // name: xxx
    data,
  });